import { Select, Input, Checkbox, Button } from "antd";
import React from "react";

const DmnValueSubmissionModal = ({
  valueType,
  handleModalSubmit,
  setFeildType,
  fieldType,
  setEditValue,
  editValue,
  editHeader,
  dmnData,
  onClose,
}: any) => {
  const { Option } = Select;

  const getUniqueValues = (data: any[], key: string) => {
    return Array.from(new Set(data.flatMap(item =>
      item[key].includes(',')
        ? item[key].split(',').map(value => value.replace(/"/g, '').trim()).filter(value => !value.includes('not') && Boolean(value))
        : [item[key].replace(/"/g, '').trim()].filter(value => !value.includes('not') && Boolean(value))
    )));
  };

  // Example usage of getUniqueValues
  const uniqueValues = getUniqueValues(dmnData, editHeader);
  console.log(uniqueValues, 'Unique Values based on editHeader');

  console.log(editValue, 'editValue');

  // Helper function to handle numeric inputs with minus sign only at the beginning
  const handleNumericInput = (value: string) => {
    // Keep minus sign only if it's at index 0, remove all other non-numeric and non-decimal characters
    if (value.startsWith('-')) {
      return '-' + value.substring(1).replace(/[^0-9.]/g, "");
    } else {
      return value.replace(/[^0-9.]/g, "");
    }
  };

  const handleDisabled = () => {
    // Default to disabled
    let disabled = true;

    if (valueType !== 'string') {
      if (fieldType === 'range') {
        // Match [a to b] or ]a to b[
        const rangeMatch = editValue.match(/(\[|\])\s*(-?[\d.]*)\s*to\s*(-?[\d.]*)\s*(\[|\])/);
        if (rangeMatch) {
          const firstBracket = rangeMatch[1];
          const firstValue = rangeMatch[2] || '';
          const secondValue = rangeMatch[3] || '';
          const secondBracket = rangeMatch[4];
          // Both values must not be just a minus sign or empty
          if (
            firstBracket &&
            firstValue !== '' && firstValue !== '-' &&
            secondBracket &&
            secondValue !== '' && secondValue !== '-'
          ) {
            disabled = false;
          }
        }
      } else if (fieldType === 'comparison') {
        // Match null or comparison like > 5, <= 10, etc.
        const comparisonMatch = editValue.match(/^(null|([><=]+)\s*(-?\d*\.?\d+))$/);
        if (comparisonMatch) {
          if (comparisonMatch[1] === 'null') {
            // null is a valid value
            disabled = false;
          } else {
            const symbol = comparisonMatch[2];
            const numValue = comparisonMatch[3];
            // Both symbol and numValue must be present and numValue not empty or just '-'
            if (
              symbol &&
              numValue !== undefined &&
              numValue !== '' &&
              numValue !== '-'
            ) {
              disabled = false;
            }
          }
        }
      } else if (fieldType === 'null') {
        // Only allow if editValue is exactly 'null'
        if (editValue === 'null') {
          disabled = false;
        }
      }
    } else {
      // valueType === 'string'
      if (fieldType === 'null') {
        // Only allow if fieldType is 'null'
        if (fieldType === 'null') {
          disabled = false;
        }
      } else if (fieldType === 'matches' || fieldType === 'matchesNone') {
        // Only allow if editValue is not empty (at least one value selected or entered)
        if (editValue && editValue.trim() !== '') {
          disabled = false;
        }
      }
    }

    return disabled;
  }

  return valueType !== 'string' ? (
    <div className="dmn-value-submission-modal-body">
      <div>
        <label className="field-label">Type</label>
        <Select
          className="select-menu dmb-4 -dmx-2"
          value={fieldType}
          onChange={(value) => {
            if (value === 'null') {
              setFeildType(value);
              setEditValue('null');
            } else {
              setFeildType(value);
              setEditValue(value === 'range' ? '] 0 to  0 [' : '< 0');
            }

          }}
        >
          <Option value="null">Null</Option>
          <Option value="comparison">Comparison</Option>
          <Option value="range">Range</Option>
        </Select>
        {fieldType === 'range' ? (
          <div>
            {(() => {
              let firstValue = '';
              let secondValue = '';
              let firstBracket = '[';
              let secondBracket = ']';


              if (editValue) {
                const rangeMatch = editValue.match(/(\[|\])\s*(-?[\d.]*)\s*to\s*(-?[\d.]*)\s*(\[|\])/) || [];
                if (rangeMatch.length > 0) {
                  firstBracket = rangeMatch[1];
                  firstValue = rangeMatch[2] || '';
                  secondValue = rangeMatch[3] || '';
                  secondBracket = rangeMatch[4];
                }
              }

              const updateEditValue = (
                newFirstValue: string,
                newSecondValue: string,
                newFirstBracket: string,
                newSecondBracket: string
              ): any => {
                setEditValue(
                  `${newFirstBracket} ${newFirstValue} to ${newSecondValue} ${newSecondBracket}`
                );
              };
              return fieldType === 'null' ? (
                <Input
                  className="input-field-style"
                  type="text"
                  placeholder="Value"
                  value=""
                  disabled
                />
              ) : (
                <div className="-dmx-2 dmb-4">
                  <div className="flex dmb-4 -dmx-2">
                    <div className="dpx-2">
                      <Input
                        className="input-field-style"
                        type="text"
                        placeholder="Value 1"
                        value={firstValue}
                        onChange={(e) => {
                          const { value } = e.target;
                          const newValue = handleNumericInput(value);
                          if (newValue !== value) {
                            e.target.value = newValue;
                          }
                          updateEditValue(
                            newValue,
                            secondValue,
                            firstBracket,
                            secondBracket
                          );
                        }}
                      />
                    </div>
                    <div className="dpx-2">
                      <Select
                        className="select-menu"
                        value={firstBracket === '[' ? 'include' : 'exclude'}
                        onChange={(value) => {
                          const newBracket =
                            value === 'include' ? '[' : ']';
                          updateEditValue(
                            firstValue,
                            secondValue,
                            newBracket,
                            secondBracket
                          );
                        }}
                      >
                        <Option value="include">Include</Option>
                        <Option value="exclude">Exclude</Option>
                      </Select>
                    </div>
                  </div>
                  <div className="flex -dmx-2">
                    <div className="dpx-2">
                      <Input
                        className="input-field-style"
                        type="text"
                        placeholder="Value 2"
                        value={secondValue}
                        onChange={(e) => {
                          const { value } = e.target;
                          const newValue = handleNumericInput(value);
                          if (newValue !== value) {
                            e.target.value = newValue;
                          }
                          updateEditValue(
                            firstValue,
                            newValue,
                            firstBracket,
                            secondBracket
                          );
                        }}
                      />
                    </div>
                    <div className="dpx-2">
                      <Select
                        className="select-menu"
                        value={secondBracket === '[' ? 'exclude' : 'include'}
                        onChange={(value) => {
                          const newBracket =
                            value === 'exclude' ? '[' : ']';
                          updateEditValue(
                            firstValue,
                            secondValue,
                            firstBracket,
                            newBracket
                          );
                        }}
                      >
                        <Option value="include">Include</Option>
                        <Option value="exclude">Exclude</Option>
                      </Select>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        ) : (
          <div className="flex -dmx-2 dmb-4">
            {(() => {
              let symbol = '>';
              let numValue = '';
              let comparisonMatch = editValue.match(/^(null|([><=]+)\s*(-?\d*\.?\d*))$/);
              if (comparisonMatch !== null) {
                if (comparisonMatch[1] === 'null') {
                  symbol = '';
                  numValue = '';
                } else {
                  symbol = comparisonMatch[2];
                  numValue = comparisonMatch[3];
                }
              } else {
                // If editValue is just a number string (e.g., "10", "9999191")
                const numberOnlyMatch = editValue.match(/^-?\d*\.?\d+$/);
                if (numberOnlyMatch) {
                  symbol = '=';
                  numValue = editValue;
                }
              }

              const updateEditValue = (
                newSymbol: string,
                newNumValue: string
              ): void => {
                if (newSymbol === '') {
                  setEditValue('null');
                } else {
                  setEditValue(`${newSymbol} ${newNumValue}`);
                }
              };

              return fieldType === 'null' ? (
                <Input
                  className="input-field-style"
                  type="text"
                  placeholder="Value"
                  value=""
                  disabled
                />
              ) : (
                <div className="flex -dmx-2 dmb-4">
                  <div className="dpx-2">
                    <Select
                      className="select-menu"
                      value={symbol}
                      onChange={(value) => {
                        updateEditValue(value, numValue);
                      }}
                      options={[
                        {
                          label: 'Greater than',
                          value: '>',
                        },
                        {
                          label: 'Less than',
                          value: '<',
                        },
                        {
                          label: 'Greater than or equal to',
                          value: '>=',
                        },
                        {
                          label: 'Less than or equal to',
                          value: '<=',
                        },
                        {
                          label: 'Equal to',
                          value: '=',
                        },
                      ]}
                    />
                  </div>

                  <div className="dpx-2">
                    <Input
                      className="input-field-style"
                      type="text"
                      placeholder="Value"
                      value={numValue}
                      onChange={(e) => {
                        const { value } = e.target;
                        const newValue = handleNumericInput(value);
                        if (newValue !== value) {
                          e.target.value = newValue;
                        }
                        updateEditValue(symbol, newValue);
                      }}
                    />
                  </div>



                </div>
              );
            })()}
          </div>
        )}
      </div>
      <div className="modal-footer">
        <Button className="modal-cancel-button" onClick={onClose}>
    Cancel
  </Button>
        <Button className="modal-submit-button" disabled={handleDisabled()} onClick={handleModalSubmit}>
          Save Conditions
        </Button>
      </div>
    </div>
  ) : (
    <>
      <div className="dmn-value-submission-modal-body">
        <div>
          <label className="field-label">Type</label>
          <Select
            className="select-menu dmb-4"
            value={fieldType}
            onChange={(value) => {
              setFeildType(value);
              setEditValue('');
            }}
          >
            <Option value="matches">Matches</Option>
            <Option value="matchesNone">Matches None</Option>
            <Option value="null">Match All</Option>
          </Select>
          {fieldType === 'null' ? (
            <div className="flex -dmx-2 dmb-4">
              <div className="dpx-2">
                <Input
                  className="input-field-style"
                  type="text"
                  placeholder="Value"
                  value=""
                  disabled
                />
              </div>
            </div>
          ) : (
            <div className="flex -dmx-2 dmb-4">
              <div className="dpx-2">
                <div className="flex flex-wrap">
                  {uniqueValues.map((value) => (
                    <div key={value} className="ml-2 mb-2">
                      <Checkbox
                        checked={editValue.split(',').map(v => v.trim()).includes(value)}
                        onChange={(e) => {
                          let newEditValue = e.target.checked
                            ? `${editValue ? `${editValue}, ` : ''}${value}`.trim() // Add value if checked
                            : editValue.split(',').map(v => v.trim()).filter(v => v !== value).join(', '); // Remove value if unchecked

                          setEditValue(newEditValue);
                        }}
                      >
                        {value}
                      </Checkbox>
                    </div>
                  ))}
                </div>
                <Input
                  className="input-field-style mt-2"
                  type="text"
                  placeholder="Value"
                  value={editValue}
                  onChange={(e) => {
                    setEditValue(e.target.value);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="modal-footer">
          <Button className="modal-cancel-button" onClick={onClose}>
    Cancel
  </Button>
        <Button
          type="primary"
          className="modal-submit-button"
          onClick={() => handleModalSubmit()}
          disabled={handleDisabled()}
        >
          Save Conditions
        </Button>
      </div>
    </>
  );
};

export default DmnValueSubmissionModal;